/** @jsxImportSource @emotion/react */
import { useMsal } from '@azure/msal-react';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';

import { homePageAnalytics } from '../../analyticsConsts';
import { ONBOARDING_PARAM } from '../../const';
import { useFilterPanelToggleContext } from '../../context/filterPanelToggle';
import { useMLRecommendations } from '../../context/mlRecommendations';
import { useMORecommendations } from '../../context/moRecommendations';
import { useNestedFilterPanelContext } from '../../context/nestedFilterPanel';
import { usePageInfo } from '../../context/pageInfo';
import { usePreferencesContext } from '../../context/preferences';
import { useRecommendations } from '../../context/recommendations';
import useMediaQuery from '../../hooks/useMediaQuery';
import useQueryParams from '../../hooks/useQueryParams';
import useStorageFilters from '../../hooks/useStorageFilters';
import homePage from '../../mocks/data/homepage';
import ClubVsCasual from '../ClubVsCasual';
import DisabilityFootball from '../DisabilityFootball';
import FAProgrammes from '../FAProgrammes';
import Footer from '../Footer';
import Hero from '../Hero';
import OnboardingModal from '../OnboardingModal';
import QuickLinks from '../QuickLinks';
import Text from '../Text';
import WaysToPlayDesktop from '../WaysToPlayDesktop';
import WaysToPlayMobile from '../WaysToPlayMobile';
import useStyles from './styles';

export const waysToPlayRef = React.createRef();
export const clubCasualRef = React.createRef();
export const faProgRef = React.createRef();
export const disabilityRef = React.createRef();

const {
  QUICK_LINK_TYPES,
  CTA_START_SEARCHING,
  CTA_START_TAILOREDSEARCH,
  HERO_BANNER,
} = homePageAnalytics;

const HomePage = () => {
  const params = useQueryParams();
  const styles = useStyles();
  const [onboardingVisible, setOnboardingVisible] = useState(false);
  const [quickSearch, setQuickSearch] = useState(false);
  const [homeData, setHomeData] = useState({});
  const { resetPreferences } = usePreferencesContext();
  const { resetRecommendations } = useRecommendations();
  const { resetMORecommendations } = useMORecommendations();
  const { clearFiltersStorage } = useStorageFilters();
  const [, setPageInfo] = usePageInfo();
  const { resetMLRecommendations } = useMLRecommendations();
  const { resetFilterPanelToggle } = useFilterPanelToggleContext();
  const { resetNestedFilterPanel } = useNestedFilterPanelContext();
  const history = useHistory();
  const { accounts } = useMsal();
  const [activeTab, setActiveTab] = useState('FOOTBALL');
  const [activeNavigationLabel, setActiveNavigationLabel] =
    useState('WILDCATS');
  const [
    activeNavigationforDisablitySection,
    setActiveNavigationforDisablitySection,
  ] = useState('PAN DISABILITY FOOTBALL');
  const [currentDisablityPage, setCurrentDisablityPage] = useState(0);
  const [marginRemoved] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [disabilityResult, setDisabilityResult] = useState(
    homeData?.DisabilityFootballData
  );
  const [faResult, setFaResult] = useState(homeData?.FAProgrammes);
  const [waysResult, setWaysResult] = useState(homeData?.WayToPlay);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isScrolledFa, setIsScrolledFa] = useState(false);
  const [isWTPContHovered, setIsWTPContHovered] = useState(false);
  const scrollContainerRef = useRef(null);
  const WaysToPlayscrollContainerRef = useRef(null);
  const FAProgramsscrollContainerRef = useRef(null);
  const [backButtonHovered, setBackButtonHovered] = useState(false);
  const [frontButtonHovered, setFrontButtonHovered] = useState(false);
  const [previousDisabled, setPreviousDisabled] = useState(true);
  const [forwardDisabled, setForwardDisabled] = useState(false);
  const [disabilityPreviousDisable, setDisabilityPreviousDisable] =
    useState(true);
  const [disabilityForwardDisable, setDisabilityForwardDisable] =
    useState(false);

  const WayToPlayData = {
    FOOTBALL: homeData.WaysToPlay,
    FUTSAL: homeData.WaysToPlay,
    'WALKING FOOTBALL': homeData.WaysToPlay,
  };

  const FAProgrammesData = {
    WILDCATS: homeData.FAProgrammes,
    'JUST PLAY': homeData.FAProgrammes,
    "SQUAD GIRLS' FOOTBALL": homeData.FAProgrammes,
    COMETS: homeData.FAProgrammes,
  };

  const DisabilityFootballHeader = {
    'AMPUTEE FOOTBALL': homeData.DisabilityFootballData,
    'PAN DISABILITY FOOTBALL': homeData.DisabilityFootballData,
    'BLIND FOOTBALL': homeData.DisabilityFootballData,
    'CEREBRAL PALSY FOOTBALL': homeData.DisabilityFootballData,
    'DEAF FOOTBALL': homeData.DisabilityFootballData,
    'FRAME FOOTBALL': homeData.DisabilityFootballData,
    'PARTIALLY SIGHTED  FOOTBALL': homeData.DisabilityFootballData,
    'POWER CHAIR FOOTBALL': homeData.DisabilityFootballData,
    'DOWNS SYNDROME': homeData.DisabilityFootballData,
    'LEARNING DISABILITY': homeData.DisabilityFootballData,
    'MENTAL HEALTH': homeData.DisabilityFootballData,
  };

  const getTotalPages = section =>
    Math.ceil((FAProgrammesData[section] || []).length / 3);
  const getTotalDisabilityPages = section =>
    Math.ceil((DisabilityFootballHeader[section] || []).length / 4);

  const handleNavigationClick = id => {
    const FAProgrammesDataArray = homeData.FAProgrammes;
    const itemFiltered = FAProgrammesDataArray.filter(item => item.name === id);
    const cardId = itemFiltered[0].id - 1;
    const cardWidth = window.innerWidth <= 768 ? 291 : 306;
    boxRef.current.scrollLeft = cardId * cardWidth;
    setActiveNavigationLabel(id);
    setCurrentPage(cardId);
    setPreviousDisabled(cardId === 0);
    setForwardDisabled(cardId === getTotalPages(id) - 1);
  };

  const handleTabClick = label => {
    const WaysToPlayDataArray = homeData.WaysToPlay;
    const itemFiltered = WaysToPlayDataArray.filter(
      item => item.name === label
    );
    if (itemFiltered.length > 0) {
      const cardId = itemFiltered[0].id - 1;
      waysToPlayboxRef.current.scrollLeft = cardId * 291;
      setActiveTab(label);
      setPreviousDisabled(cardId === 0);
      setForwardDisabled(cardId === getTotalPages(label) - 1);
    }
  };

  const handleDisablityNavigationClick = section => {
    const disablityDataArray = homeData.DisabilityFootballData;
    const itemFiltered = disablityDataArray.filter(
      item => item.name === section
    );
    const cardId = itemFiltered[0].id - 1;
    const cardWidth = window.innerWidth <= 768 ? 291 : 306;

    const scrollPosition = cardId * cardWidth;
    if (disablityboxRef.current) {
      disablityboxRef.current.scrollLeft = scrollPosition;
    }

    setActiveNavigationforDisablitySection(section);

    // Calculate page index
    const itemsPerPage = window.innerWidth <= 768 ? 1 : 4;
    const pageIndex = Math.floor(cardId / itemsPerPage);
    const totalPages = Math.ceil(disablityDataArray.length / itemsPerPage);

    setCurrentDisablityPage(pageIndex);
    setDisabilityPreviousDisable(pageIndex === 0);
    setDisabilityForwardDisable(pageIndex === totalPages - 1);
  };

  const handleKeyDown = (event, index, label, actionType) => {
    if (event.key === 'Enter') {
      switch (actionType) {
        case 'navigation':
          handleNavigationClick(label);
          break;
        case 'disabilityNavigation':
          handleDisablityNavigationClick(label.name);
          break;
        case 'waystoPlayNavigation':
          handleTabClick(label);
          break;
        case 'previousButton':
          handlePreviousButton();
          break;
        case 'forwardButton':
          handleForwardButton();
          break;
        case 'renderDots':
          handleDotFAProgrammes(index);
          break;
        case 'disabilityPreviousButton':
          handleDisablityPreviousButton();
          break;
        case 'disabilityForwardButton':
          handleDisablityForwardButton();
          break;
        case 'disabilityRenderDots':
          handleDotClick(index);
          break;
        default:
          return;
      }
    }
  };

  const scrollToItem = index => {
    const container = scrollContainerRef.current;
    const item = container.children[index];
    const itemOffsetLeft = item.offsetLeft;
    let width = window.innerWidth;
    if (width < 768) {
      container.scrollLeft = itemOffsetLeft - 20;
    } else {
      container.scrollLeft = itemOffsetLeft - 500;
    }
  };
  const MQtoHideQuickLinks = useMediaQuery('screen and (max-width: 600px)');

  useEffect(() => {
    const handleScroll = () => {
      if (scrollContainerRef.current.scrollLeft > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    const scrollContainer = scrollContainerRef.current;
    scrollContainer.addEventListener('scroll', handleScroll);

    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (FAProgramsscrollContainerRef.current.scrollLeft > 0) {
        setIsScrolledFa(true);
      } else {
        setIsScrolledFa(false);
      }
    };
    const scrollContainer = FAProgramsscrollContainerRef.current;
    scrollContainer.addEventListener('scroll', handleScroll);

    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToItemFAPrograms = index => {
    const container = FAProgramsscrollContainerRef.current;
    const item = container.children[index];
    const itemOffsetLeft = item.offsetLeft;
    let width = window.innerWidth;
    if (width < 768) {
      container.scrollLeft = itemOffsetLeft - 20;
    } else {
      container.scrollLeft = itemOffsetLeft - 500;
    }
  };

  const waysToPlayboxRef = useRef(null);
  const boxRef = useRef(null);
  const disablityboxRef = useRef(null);

  useEffect(() => {
    boxRef.current = document.querySelector('.FAProgrammes-container');
    disablityboxRef.current = document.querySelector(
      '.DisabilityFootball-container'
    );
    FAProgramsscrollContainerRef.current = document.querySelector(
      '.FAProgrammes-container'
    );
  }, []);

  const handlePreviousButton = () => {
    if (currentPage > 0 && boxRef.current) {
      boxRef.current.scrollLeft -= boxRef.current.clientWidth;
      const newPage = currentPage - 1;
      setCurrentPage(newPage);
      setPreviousDisabled(newPage === 0);
      setForwardDisabled(newPage === getTotalPages(activeNavigationLabel) - 1);
    }
  };

  const handleForwardButton = () => {
    if (
      currentPage < getTotalPages(activeNavigationLabel) - 1 &&
      boxRef.current
    ) {
      boxRef.current.scrollLeft += boxRef.current.clientWidth;
      const newPage = currentPage + 1;
      setCurrentPage(newPage);
      setPreviousDisabled(newPage === 0);
      setForwardDisabled(newPage === getTotalPages(activeNavigationLabel) - 1);
    }
  };

  const renderPageDots = () =>
    Array.from({ length: getTotalPages(activeNavigationLabel) }).map((_, i) => (
      <div
        key={i}
        css={styles.dotStyles({ isActive: i === currentPage })}
        onClick={() => handleDotFAProgrammes(i)}
        role="tab"
        tabIndex={0}
        onKeyDown={event => handleKeyDown(event, i, null, 'renderDots')}
        aria-label={`Slide ${i + 1}`}
        aria-selected={i === currentPage}
      />
    ));

  const handleDisablityPreviousButton = () => {
    if (currentDisablityPage > 0 && disablityboxRef.current) {
      disablityboxRef.current.scrollLeft -= disablityboxRef.current.clientWidth;
      const newPage = currentDisablityPage - 1;
      setCurrentDisablityPage(newPage);
      setDisabilityPreviousDisable(newPage === 0);
      setDisabilityForwardDisable(false); // Not last page anymore
    }
  };

  const handleDisablityForwardButton = () => {
    const totalPages = getTotalDisabilityPages(
      activeNavigationforDisablitySection
    );
    if (currentDisablityPage < totalPages - 1 && disablityboxRef.current) {
      disablityboxRef.current.scrollLeft += disablityboxRef.current.clientWidth;
      const newPage = currentDisablityPage + 1;
      setCurrentDisablityPage(newPage);
      setDisabilityPreviousDisable(newPage === 0);
      setDisabilityForwardDisable(newPage === totalPages - 1);
    }
  };

  const renderDisablityPageDots = () =>
    Array.from({
      length: getTotalDisabilityPages(activeNavigationforDisablitySection),
    }).map((_, i) => (
      <div
        key={i}
        css={styles.dotStyles({ isActive: i === currentDisablityPage })}
        onClick={() => handleDotClick(i)}
        role="tab"
        tabIndex={0}
        onKeyDown={event =>
          handleKeyDown(event, i, null, 'disabilityRenderDots')
        }
        aria-label={`Slide ${i + 1}`}
        aria-selected={i === currentPage}
      />
    ));

  const handleDotFAProgrammes = index => {
    if (boxRef.current) {
      let width = boxRef.current.clientWidth;
      boxRef.current.scrollLeft = width * index;
      setCurrentPage(index);
    }
  };
  const handleDotClick = index => {
    if (disablityboxRef.current) {
      let width = disablityboxRef.current.clientWidth;
      disablityboxRef.current.scrollLeft = width * index;
      setCurrentDisablityPage(index);
    }
  };

  let width = window.innerWidth;

  useEffect(() => {
    // Remove applied filters from session storage
    clearFiltersStorage();

    // Resetting contexts and local storage
    resetPreferences();
    resetRecommendations();
    resetMORecommendations();
    resetMLRecommendations();
    resetFilterPanelToggle();
    resetNestedFilterPanel();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setHomeData(homePage);
    setDisabilityResult(homePage.DisabilityFootballData);
    setFaResult(homePage.FAProgrammes);
    setWaysResult(homePage.WaysToPlay);
  }, []);

  useEffect(() => {
    // set path information for b2c url redirect
    localStorage.setItem('pathInfomation', window.location.pathname);

    if (params.get(ONBOARDING_PARAM)) {
      setOnboardingVisible(true);
    }
    if (params.get('quick')) {
      setQuickSearch(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // reset the page name when on-boarding modal is closed
    // user should only be at home page to close modal.
    onboardingVisible ? setPageInfo('onboardingModal') : setPageInfo('home');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onboardingVisible, accounts]);

  return (
    <div css={styles.base} id="main-content">
      {!onboardingVisible && <QuickLinks />}
      {homeData.hero && (
        <Hero
          isHomePage={true}
          wrapperId={HERO_BANNER}
          ctaId1={CTA_START_SEARCHING}
          ctaId2={CTA_START_TAILOREDSEARCH}
          css={styles.hero}
          overlayVariation={4}
          {...homeData.hero}
          ctaOnClick={isQuickSearch => {
            setOnboardingVisible(true);
            isQuickSearch ? setQuickSearch(true) : setQuickSearch(false);
          }}
        />
      )}
      <div>
        <section css={styles.findFootballSection}>
          {onboardingVisible && (
            <OnboardingModal
              onClose={() => {
                setOnboardingVisible(false);
                history.push('/');
              }}
              isVisible={onboardingVisible}
              quickSearch={quickSearch}
            />
          )}
        </section>
        {width > 576 && (
          <div css={styles.waysToPlayContainer} ref={waysToPlayRef}>
            <div css={styles.waysToPlayinnerContainer}>
              <div css={styles.ways(MQtoHideQuickLinks)}>
                <div css={styles.border}></div>
                <Text as="h2" size="5" css={styles.waysToPlayHead}>
                  Ways to play
                </Text>
              </div>
              <div
                css={styles.waysToPlayCards}
                onMouseEnter={() => setIsWTPContHovered(true)}
                onMouseLeave={() => setIsWTPContHovered(false)}
              >
                {homeData.WaysToPlay &&
                  homeData.WaysToPlay?.map((res, index) => {
                    return (
                      <WaysToPlayDesktop
                        ctaId={QUICK_LINK_TYPES[index]}
                        {...res}
                        key={index}
                        indexVal={index}
                        isWTPContHovered={isWTPContHovered}
                      />
                    );
                  })}
              </div>
            </div>
          </div>
        )}
        {width < 576 && (
          <div css={styles.waysToPlayMobileTabContainer} ref={waysToPlayRef}>
            <div css={styles.WaysinnerContainer}>
              <div css={styles.ways}>
                <div css={styles.border}></div>
                <Text as="h2" size="5" css={styles.waysToPlayHead}>
                  Ways to play
                </Text>
              </div>
              <div css={styles.WaysToPlayScrollContainer}>
                <div
                  css={styles.navTab}
                  className="WaysToPlay-container-tabs"
                  ref={WaysToPlayscrollContainerRef}
                >
                  {Object.keys(WayToPlayData).map(label => (
                    <div
                      role="button"
                      key={label}
                      css={styles.waysHeader(activeTab === label)}
                      onClick={() => {
                        handleTabClick(label);
                      }}
                      onKeyDown={event =>
                        handleKeyDown(
                          event,
                          null,
                          label,
                          'waystoPlayNavigation'
                        )
                      }
                    >
                      {label}
                    </div>
                  ))}
                </div>
              </div>
              <div css={styles.highlightborder}></div>
              <div css={styles.waysToPlayCards}>
                <>
                  <div className="WaysToPlay-container" ref={waysToPlayboxRef}>
                    {waysResult?.map((item, index) => (
                      <WaysToPlayMobile
                        key={index}
                        ctaId={QUICK_LINK_TYPES[index]}
                        indexVal={index}
                        {...item}
                      />
                    ))}
                  </div>
                </>
              </div>
            </div>
          </div>
        )}
        <div css={styles.clubVSTeamContainer} ref={clubCasualRef}>
          <div css={styles.clubVSTeamInnerContainer}>
            <div css={styles.cVSf}>
              <div css={styles.cVSfborder}></div>
              <Text
                as="h2"
                size="5"
                css={[styles.waysToPlayHead, styles.clubSessionalHeader]}
              >
                Team vs sessional football
              </Text>
            </div>
            <div css={styles.clubVsFootballCards}>
              {homeData.teamVsFootball &&
                homeData.teamVsFootball?.map((res, index) => {
                  return (
                    <ClubVsCasual
                      ctaId={QUICK_LINK_TYPES[index]}
                      {...res}
                      key={index}
                      indexVal={index}
                    />
                  );
                })}
            </div>
          </div>
          <div>
            <img
              src="/images/desktop/home/graphic-divider-desktop.svg"
              alt="/images/desktop/home/graphic-divider-desktop.svg"
              css={styles.disabilityFootballDivider}
            ></img>
          </div>
        </div>
        <div css={styles.FAProgrammesContainer} ref={faProgRef}>
          <div css={styles.FAProgrammesinnerContainer}>
            <div css={styles.FAprogrammes}>
              <div css={styles.border}></div>
              <Text as="h2" size="5" css={[styles.waysToPlayHead]}>
                England Football programmes
              </Text>
            </div>
            <div css={styles.FAProgrammesScrollContainer}>
              <div
                css={styles.navigation(isScrolledFa)}
                className="FAPrograms-container-tabs"
                ref={FAProgramsscrollContainerRef}
              >
                {Object.keys(FAProgrammesData).map((label, index) => (
                  <div
                    role="button"
                    key={label}
                    tabIndex={0}
                    css={styles.faprogrammeHeader(
                      activeNavigationLabel === label
                    )}
                    onClick={() => {
                      handleNavigationClick(label);

                      scrollToItemFAPrograms(index);
                    }}
                    onKeyDown={event =>
                      handleKeyDown(event, null, label, 'navigation')
                    }
                  >
                    {label}
                  </div>
                ))}
              </div>
            </div>
            <div css={styles.highlightborder}></div>
            <div css={styles.FAProgrammesCards}>
              <>
                <div
                  className="FAProgrammes-container"
                  ref={boxRef}
                  tabIndex={-1}
                >
                  {faResult?.map((item, index) => (
                    <FAProgrammes
                      key={index}
                      ctaId={QUICK_LINK_TYPES[index]}
                      indexVal={index}
                      {...item}
                    />
                  ))}
                </div>
                <span
                  role="button"
                  tabIndex="0"
                  className="backbutton"
                  onClick={handlePreviousButton}
                  onKeyDown={event =>
                    handleKeyDown(event, null, null, 'previousButton')
                  }
                  onMouseEnter={() => setBackButtonHovered(true)}
                  onMouseLeave={() => setBackButtonHovered(false)}
                >
                  <img
                    src={
                      previousDisabled
                        ? '/images/desktop/home/backButtonDisable.svg'
                        : backButtonHovered
                        ? '/images/desktop/home/backbutton.svg'
                        : '/images/desktop/home/backbuttonHover.svg'
                    }
                    alt="/images/desktop/home/backbutton.svg"
                  />
                </span>
                <span
                  role="button"
                  tabIndex="0"
                  className="frontbutton"
                  onClick={handleForwardButton}
                  onKeyDown={event =>
                    handleKeyDown(event, null, null, 'forwardButton')
                  }
                  onMouseEnter={() => setFrontButtonHovered(true)}
                  onMouseLeave={() => setFrontButtonHovered(false)}
                >
                  <img
                    src={
                      forwardDisabled
                        ? '/images/desktop/home/frontButtonDisable.svg'
                        : frontButtonHovered
                        ? '/images/desktop/home/frontButtonHover.svg'
                        : '/images/desktop/home/frontButtonDefault.svg'
                    }
                    alt="/images/desktop/home/frontside.svg"
                  />
                </span>
                <div css={styles.Dots}>{renderPageDots()}</div>
              </>
            </div>
          </div>
        </div>

        <div>
          <img
            src="/images/desktop/home/disabilityFootball/disabilityFootballdivider.svg"
            alt="/images/desktop/home/disabilityFootball/disabilityFootballdivider.svg"
            css={styles.disabilityFootballDivider}
          ></img>
        </div>

        <div
          css={styles.DisabilityFootballContainer(marginRemoved)}
          ref={disabilityRef}
        >
          <div css={styles.DisabilityFootballinnerContainer(marginRemoved)}>
            <div css={styles.DisabilityFootballprogrammes(marginRemoved)}>
              <div css={styles.border}></div>
              <Text as="h2" size="5" css={[styles.waysToPlayHead]}>
                Disability football
              </Text>
            </div>
            <div css={styles.DisabilityFootballScrollContainer}>
              <div
                css={styles.disablitynavigation(isScrolled, marginRemoved)}
                className="DisabilityFootball-container-tabs"
                ref={scrollContainerRef}
                tabIndex={-1}
              >
                {homeData?.DisabilityFootballData?.map((label, index) => (
                  <div
                    key={label.id}
                    role="button"
                    css={[
                      styles.header,
                      activeNavigationforDisablitySection === label.name &&
                        styles.active,
                    ]}
                    onClick={() => {
                      handleDisablityNavigationClick(label.name);
                      scrollToItem(index);
                    }}
                    tabIndex={0}
                    onKeyDown={event =>
                      handleKeyDown(event, null, label, 'disabilityNavigation')
                    }
                  >
                    {label.name}
                  </div>
                ))}
              </div>
            </div>
            <div css={styles.navigationborder(marginRemoved)}></div>
            <div css={styles.DisabilityFootballCards}>
              <>
                <div
                  className="DisabilityFootball-container"
                  ref={disablityboxRef}
                  tabIndex={-1}
                >
                  {disabilityResult?.map((item, index) => (
                    <DisabilityFootball
                      ctaOnClick={isQuickSearch => {
                        setOnboardingVisible(true);
                        isQuickSearch
                          ? setQuickSearch(true)
                          : setQuickSearch(false);
                      }}
                      key={index}
                      ctaId={QUICK_LINK_TYPES[index]}
                      indexVal={index}
                      {...item}
                    />
                  ))}
                </div>
                <span
                  role="button"
                  tabIndex="0"
                  onClick={handleDisablityPreviousButton}
                  className="disabilitybackbutton"
                  onKeyDown={event =>
                    handleKeyDown(event, null, null, 'disabilityPreviousButton')
                  }
                  onMouseEnter={() => setBackButtonHovered(true)}
                  onMouseLeave={() => setBackButtonHovered(false)}
                >
                  <img
                    src={
                      disabilityPreviousDisable
                        ? '/images/desktop/home/disabilityFootball/backButtonDisable.svg'
                        : backButtonHovered
                        ? '/images/desktop/home/disabilityFootball/backbutton.svg'
                        : '/images/desktop/home/disabilityFootball/backbuttonDefault.svg'
                    }
                    alt="/images/desktop/home/disabilityFootball/backbutton.svg"
                  />
                </span>
                <span
                  role="button"
                  tabIndex="0"
                  onClick={handleDisablityForwardButton}
                  className="frontbutton"
                  onKeyDown={event =>
                    handleKeyDown(event, null, null, 'disabilityForwardButton')
                  }
                  onMouseEnter={() => setFrontButtonHovered(true)}
                  onMouseLeave={() => setFrontButtonHovered(false)}
                >
                  <img
                    src={
                      disabilityForwardDisable
                        ? '/images/desktop/home/disabilityFootball/frontButtonDisable.svg'
                        : frontButtonHovered
                        ? '/images/desktop/home/disabilityFootball/frontButtonHover.svg'
                        : '/images/desktop/home/disabilityFootball/frontButtonDefault.svg'
                    }
                    alt="forward button"
                  />
                </span>

                <div css={styles.Dots}>{renderDisablityPageDots()}</div>
              </>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default HomePage;
